import React from 'react';

import CrossIcon from "../../../assets/icons/cross";

export default function SelectInput({
    id,
    label,
    placeholder = null,
    required = false,
    options = [],
    value = "",
    onChange,
    disabled = false,
    helper = '',
    error = '',
}) {
    if (placeholder === null && value === "") {
        onChange(options[0].value);
    }

    return (
        <div className="w-full relative">
            <label
              htmlFor={id}
              className={`block mb-2 font-medium ${error ? 'text-red-700' : 'text-gray-900'}`}
            >
                {`${label} ${required ? "*" : ""}`}
            </label>
            <div className="relative">
                <select
                  id={id}
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 pr-10 ${disabled ? 'cursor-not-allowed' : ''} ${error ? 'border-red-500 text-red-900 placeholder-red-700' : ''}`}
                  value={value}
                  onChange={e => onChange(e.target.value)}
                  required={required}
                  disabled={disabled}
                >
                    {placeholder && <option value="">{placeholder}</option>}

                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                {placeholder && !required && (
                    <div
                        className={`absolute inset-y-0 right-0 flex items-center mr-7 w-7 p-1 self-center text-gray-600 hover:bg-gray-200 rounded-full ${disabled && "cursor-not-allowed"}`}
                        onClick={() => !disabled && onChange("")}
                    >
                        <CrossIcon />
                    </div>
                )}
            </div>
            {helper && <p id={`helper-${id}`} className="mt-2 text-sm text-gray-600">{helper}</p>}
            {error && <p id={`error-${id}`} className="mt-2 text-sm text-red-600">{error}</p>}
            {required && !value && <p id={`required-${id}`} className="mt-2 text-sm text-red-600">Champ obligatoire.</p>}
        </div>
    );
};
